import { cn } from '@/shared/lib/utils/classnames';
import type { SectionBlock as SectionBlockType } from '@/shared/types/blocks';
import { BlockRenderer } from '../BlockRenderer';
import { HeadingBlock } from './HeadingBlock';

interface SectionBlockProps extends Omit<SectionBlockType, 'type' | 'id'> {
  onToolClick?: (toolId: string) => void;
  /** 연결된 YouTube 영상 ID */
  linkedVideoId?: string;
}

export function SectionBlock({
  title,
  counter,
  items,
  marginBottom,
  gap,
  onToolClick,
  linkedVideoId,
}: SectionBlockProps) {
  return (
    <section className={cn('flex flex-col gap-3', marginBottom && `mb-${marginBottom}`)}>
      {(title || counter) && (
        <div className="flex justify-between items-center">
          {title && <HeadingBlock level={2} text={title} />}
          {counter && <span className="label-smaller text-label-alternative">{counter}</span>}
        </div>
      )}
      <BlockRenderer
        blocks={items}
        onToolClick={onToolClick}
        linkedVideoId={linkedVideoId}
        style={gap ? { gap: `${gap}px` } : undefined}
      />
    </section>
  );
}
